import { EntityKindPicker } from '@backstage/plugin-catalog-react';
import { usePermission } from '@backstage/plugin-permission-react';

// Environments, templates and Users are what people browse for (the catalog only holds members of
// the three portal groups, so the user directory is small and relevant). Groups stay in the catalog
// (owner links, sign-in and permission checks depend on them) but are not offered in the Kind
// dropdown; their entity pages still open from an owner or Member of link.
export const BROWSABLE_KINDS = ['Component', 'API', 'System', 'Resource', 'Template', 'User'];

// Locations only record where catalog entities were loaded from, and managing them is for Platform
// Engineers, so only Admin DevOps are offered the kind.
export const ADMIN_ONLY_KINDS = ['Location'];

// The permission the adminOnly module keys off (scaffolder.template.management). The permission
// policy (demoTemplatePolicy.ts) grants it to Admin DevOps only, so it doubles as "is a platform
// engineer". Declared inline because the app does not depend on @backstage/plugin-scaffolder-common.
const platformEngineerPermission = {
  type: 'basic',
  name: 'scaffolder.template.management',
  attributes: {},
} as const;

export function KindPicker(props: { initialFilter?: string }) {
  const { allowed } = usePermission({ permission: platformEngineerPermission });
  return (
    <EntityKindPicker
      initialFilter={props.initialFilter}
      allowedKinds={allowed ? [...BROWSABLE_KINDS, ...ADMIN_ONLY_KINDS] : BROWSABLE_KINDS}
    />
  );
}
